import React, { Component } from 'react';
import './ItemMintDetails.css';
import ItemLiquidityGraph from "./ItemLiquidityGraph";
import * as encryptUtils from './encryptDecryptUtils';
import * as loggingUtils from './utils/loggingUtils';
import { CrossmintPayButton } from "@crossmint/client-sdk-react-ui";
import { RiQuestionLine } from "react-icons/ri";

const axios = require('axios');
const {
  REACT_APP_IS_MAINNET,
} = process.env;

class ItemMintDetails extends Component {
  constructor(props) {
    super(props);
    this.purchaseNFT = this.purchaseNFT.bind(this);
    this.getTimeLeft = this.getTimeLeft.bind(this);
    this.buyBondingCurveItem = this.buyBondingCurveItem.bind(this);
    this.sellBondingCurveItem = this.sellBondingCurveItem.bind(this);
    this.handleClickMarketplace = this.handleClickMarketplace.bind(this);
    this.setShouldShowBuyMessage = this.setShouldShowBuyMessage.bind(this);
    this.setShouldShowSellMessage = this.setShouldShowSellMessage.bind(this);
    this.saveEmail = this.saveEmail.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.state = {
      ethToWeiConversion: 1000000000000000000,
      USDPrice: "Invalid coinbase exchange rate request",
      ethBalance: 0,
      timeLeft: null,
      shouldShowBuyMessage: false,
      shouldShowSellMessage: false,
      email: null
    }
  }

  setShouldShowBuyMessage(shouldShowBuyMessage) {
    this.setState({
      shouldShowBuyMessage
    });
  }

  setShouldShowSellMessage(shouldShowSellMessage) {
    this.setState({
      shouldShowSellMessage
    });
  }

  async handleClickMarketplace() {
    loggingUtils.logEvent(
      this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
      'item_dedicated_page',
      'item_dedicated_page_click_marketplace',
      'info',
      "https://the402.xyz",
      {
        item: this.props.item
      },
    );
    let route = "/marketplace/" + this.props.item.authUUID + "?protocol=" + this.props.item.protocol;
    window.location.href = window.location.origin + route;
  }

  async purchaseNFT() {
    if(this.props.item.isMintComplete || this.props.item.mintCount === this.props.item.mintLimit) {
      window.location.href = window.location.origin + "/marketplace/" + this.props.item.authUUID;
    } else {
      if(this.state.ethBalance < this.props.item.mintPrice) {
        return;
      }
      this.props.setTransactionStatus("Pending");
      let didApprove = await encryptUtils.mintToken(this.props.account.address, this.props.item.tokenId, this.props.item.mintPrice);
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
          'item_dedicated_page',
          'item_dedicated_page_mint_nft',
          'info',
          "https://the402.xyz",
          {
            item: this.props.item
          },
        );
      } else {
        this.props.setTransactionStatus("None");
      }
    }
  }

  async sellBondingCurveItem() {
    if (window.ethereum == null) {
      window.open("https://metamask.app.link/dapp/" + window.location.host + window.location.pathname + window.location.search);
      return;
    }
    if(this.props.account != null) {
      this.props.setTransactionStatus("Pending");
      let didApprove = await encryptUtils.sellBondingCurveItem(this.props.account.address, this.props.item, this.props.item.protocol);
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
          'item_dedicated_page',
          'item_dedicated_page_sell_bonding_curve_nft',
          'info',
          "https://the402.xyz",
          {
            item: this.props.item
          },
        );
      } else {
        this.props.setTransactionStatus("None");
      }
    }
  }

  async buyBondingCurveItem() {
    if (window.ethereum == null) {
      window.open("https://metamask.app.link/dapp/" + window.location.host + window.location.pathname + window.location.search);
      return;
    }
    if(this.state.ethBalance < this.props.item.mintPrice) {
      alert(
        "You do not have enough funds in your wallet to purchase an edition"
      );
      return;
    }
    if(this.props.account != null) {
      this.props.setTransactionStatus("Pending");
      let didApprove = await encryptUtils.buyBondingCurveItem(this.props.account.address, this.props.item, this.props.item.protocol);
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account != null ? this.props.account.address : encryptUtils.getWalletUnconnectedUserId(),
          'item_dedicated_page',
          'item_dedicated_page_mint_bonding_curve_nft',
          'info',
          "https://the402.xyz",
          {
            item: this.props.item
          },
        );
      } else {
        this.props.setTransactionStatus("None");
      }
    }
  }

  async componentDidMount() {
    let data = await axios.get("https://api.coinbase.com/v2/exchange-rates", { params: { currency: "ETH" } });
    if(data != null) {
      this.setState({
        USDPrice: data["data"]["data"]["rates"]["USD"]
      })
    }

    if(this.props.account != null) {
      let balance = await encryptUtils.getEthBalance(this.props.account.address);
      this.setState({
        ethBalance: balance,
      });
    }

    setInterval(this.getTimeLeft, 1000);
  }

  async componentDidUpdate(prevProps) {
    if(prevProps.account !== this.props.account && this.props.account != null) {
      let balance = await encryptUtils.getEthBalance(this.props.account.address);
      this.setState({
        ethBalance: balance,
      });
    }
  }

  getTimeLeft() {
    let timeLeft;
    if(this.props.item.liquidityPeriodLength === "0") {
      timeLeft = "Infinite"
    } else if(this.props.item.liquidityPeriodStart === "-1") {
      let secondsLeft = parseInt(this.props.item.liquidityPeriodLength);
      let days = Math.floor(secondsLeft / 86400);
      secondsLeft -= days * 86400;
      let hours = Math.floor(secondsLeft / 3600);
      secondsLeft -= hours * 3600;
      let minutes = Math.floor(secondsLeft / 60);
      secondsLeft -= minutes * 60;
      let seconds = Math.floor(secondsLeft);
      timeLeft = days.toLocaleString('en-US', {minimumIntegerDigits: 2, maximumIntegerDigits: 2, useGrouping:false}) + ":" + hours.toLocaleString('en-US', {minimumIntegerDigits: 2, maximumIntegerDigits: 2, useGrouping:false}) + ":" + minutes.toLocaleString('en-US', {minimumIntegerDigits: 2, maximumIntegerDigits: 2, useGrouping:false}) + ":" + seconds.toLocaleString('en-US', {minimumIntegerDigits: 2, maximumIntegerDigits: 2, useGrouping:false}) + " after buy"
    } else {
      let end = parseInt(this.props.item.liquidityPeriodLength) + parseInt(this.props.item.liquidityPeriodStart);
      let secondsLeft = end - Date.now()/1000;
      if(secondsLeft < 0) {
        timeLeft = "Finished"
      } else {
        let days = Math.floor(secondsLeft / 86400);
        secondsLeft -= days * 86400;
        let hours = Math.floor(secondsLeft / 3600);
        secondsLeft -= hours * 3600;
        let minutes = Math.floor(secondsLeft / 60);
        secondsLeft -= minutes * 60;
        let seconds = Math.floor(secondsLeft);
        timeLeft = days.toLocaleString('en-US', {minimumIntegerDigits: 2, maximumIntegerDigits: 2, useGrouping:false}) + ":" + hours.toLocaleString('en-US', {minimumIntegerDigits: 2, maximumIntegerDigits: 2, useGrouping:false}) + ":" + minutes.toLocaleString('en-US', {minimumIntegerDigits: 2, maximumIntegerDigits: 2, useGrouping:false}) + ":" + seconds.toLocaleString('en-US', {minimumIntegerDigits: 2, maximumIntegerDigits: 2, useGrouping:false})
      }
    }
    this.setState({
      timeLeft,
    });
  }

  async saveEmail() {
    if(this.state.email != null) {
      localStorage.setItem("crossmint_user_id", this.state.email.toLowerCase());
      await this.props.setCrossmintUserId(this.state.email.toLowerCase());
    }
  }

  handleEmailChange(event) {
    this.setState({
      email: event.target.value,
    });
  }

  render() {
    let mintProgressPercent = 0;
    mintProgressPercent = ((1- (this.props.item.mintCount / this.props.item.mintLimit)) * 358);

    let videoMintProgressBar = {
      background: "linear-gradient(270deg, #B7AFA1 0%, #A48E68 100%)",
      boxShadow: "0px 0px 2px #AE7A1D",
      borderRadius: "20px",
      width: `${mintProgressPercent}px`,
      height: "10px",
    }

    let whArgs;
    let whArgsSerialized;

    if(this.props.crossmintUserId != null) {
      whArgs = {
        userId: this.props.crossmintUserId,
        tokenId: this.props.item.tokenId,
        isMainnet: REACT_APP_IS_MAINNET !== "testnet",
        isCreatorOwned: this.props.item.protocol === "liquidv2"
      };
      whArgsSerialized = JSON.stringify(whArgs);
    }

    let button;

    if(
      this.props.item.authUUID in this.props.authUUIDCrossmintClientMapping &&
      this.props.authUUIDCrossmintClientMapping[this.props.item.authUUID] !== "liquid"
    ) {
      button = (
        <CrossmintPayButton
          collectionTitle={`${this.props.item.name}`}
          collectionDescription={`${this.props.item.description}`}
          className="my-custom-crossmint-button"
          clientId={`${this.props.authUUIDCrossmintClientMapping[this.props.item.authUUID]}`}
          environment="production"
          mintConfig={{
            "type":"erc-1155",
            "totalPrice": `${(this.props.item.mintPrice/ this.state.ethToWeiConversion).toString()}`,
            "collectionId": `${parseInt(this.props.item.collectionId)}`
          }}
          whPassThroughArgs={whArgsSerialized}
        />
      );
    } else {
      button = (
        <CrossmintPayButton
          collectionTitle={`${this.props.item.name}`}
          collectionDescription={`${this.props.item.description}`}
          className="my-custom-crossmint-button"
          clientId={
            REACT_APP_IS_MAINNET !== "testnet"
              ?
            "a7e8548b-7530-4389-8923-cf367d1091cf"
              :
            "77c4ec0a-6c04-4677-83c2-832111fd4639"
          }
          environment={
            REACT_APP_IS_MAINNET !== "testnet"
              ?
            "production"
              :
            "staging"
          }
          mintConfig={{
            "type":"erc-1155",
            "totalPrice": `${(this.props.item.mintPrice/ this.state.ethToWeiConversion).toString()}`,
            "tokenId": `${parseInt(this.props.item.tokenId)}`
          }}
          whPassThroughArgs={whArgsSerialized}
        />
      );
    }

    let crossmintPayButton = (
      this.props.item != null && this.props.item.isMintReady && this.props.crossmintUserId != null && this.state.timeLeft !== "Finished"
        ?
      <div className="flex items-center justify-center">
        {button}
      </div>
        :
      this.props.item != null && this.props.item.isMintReady && this.props.crossmintUserId == null
        ?
      <div className="flex flex-col justify-center">
        <div className="flex font-bold justify-center dark:text-white text-black w-full px-4">
        Or enter email to buy with credit card
        </div>
      <div className="flex flex-col items-center justify-center px-12 mt-4">
        <input
          placeholder="Enter email to pay with credit card"
          type="text"
          className="placeholder-gray-500 dark:placeholder-gray-400 font-medium sm:text-base text-xs w-full px-2 sm:px-4 rounded-lg flex justify-center items-center h-12 dark:text-white bg-gray-200 dark:bg-zinc-800"value={this.state.email}
          onChange={this.handleEmailChange}
        />
        <button
          className="mt-4 mb-4 cursor-pointer elative hover:-translate-y-0 hover:scale-105 duration-500 ml-4 w-20 sm:w-32 h-10 flex justify-center items-center text-sm sm:text-sm font-bold bg-blue-600 rounded-lg text-white"
          onClick={async () => await this.saveEmail()}
        >
          Submit
        </button>
      </div>
      </div>
        :
      null
    );

    if(!(this.props.item.authUUID in this.props.authUUIDCrossmintClientMapping)) {
      crossmintPayButton = null;
    }

    return (
      <div className = "flex flex-col">
        {
          this.props.protocol === "liquid" || this.props.protocol === "liquidv2"
            ?
          <div className="bg-gray-100 dark:bg-custom-gray justify-around flex flex-col w-80 sm:w-112 rounded-lg max-h-[640px] min-h-[420px] border-2 dark:border-0 dark:shadow-[0px_0px_2px_#787878]">
            <div>
              <div className="text-gray-500 dark:text-gray-400 ml-4 font-medium text-md mt-2">
                {
                  !this.props.item.isNonLiquid
                    ?
                  "Time remaining to buy or sell an NFT"
                    :
                  "Time remaining to buy an NFT"
                }
              </div>
              <div className="text-black ml-4 dark:text-white font-bold text-5xl w-64 tracking-wide">
                {this.state.timeLeft}
              </div>
              {
                this.state.timeLeft != null && this.state.timeLeft !== "Infinite" && this.state.timeLeft !== "Finished"
                  ?
                <div className="text-black ml-4 dark:text-zinc-400 text-zinc-400 font-medium text-md w-64 flex">
                  <div className="w-16 flex justify-center px-5">
                    DAYS
                  </div>
                  <div className="w-16 flex justify-center px-10">
                    HR
                  </div>
                  <div className="w-16 flex justify-center px-9">
                    MIN
                  </div>
                  <div className="w-16 flex justify-center px-9">
                    SEC
                  </div>
                </div>
                  :
                null
              }
              {
                this.props.item.parameters.length > 1
                  ?
                <div className="dark:text-white text-black w-full px-4 mt-4">
                  {
                    !this.props.item.isNonLiquid
                      ?
                    "When you buy an edition, the price of the next edition will go up. When you sell an edition, the price of the next edition will go down."
                      :
                    "When you buy an edition, the price of the next edition will go up."
                  }
                </div>
                  :
                null
              }
              <div className="dark:text-white text-black w-full px-4 mt-4">
                {
                  this.state.timeLeft === "Infinite" && !this.props.item.isNonLiquid
                    ?
                  "This item is always liquid, you can buy and sell freely forever."
                    :
                  this.state.timeLeft !== "Infinite" && !this.props.item.isNonLiquid
                    ?
                  "While the countdown is still going, you can buy and sell freely."
                    :
                  this.state.timeLeft === "Infinite" && this.props.item.isNonLiquid
                    ?
                  "This item is always available, you can buy forever."
                    :
                  "While the countdown is still going, you can buy."
                }
              </div>
            </div>
            {
              this.state.timeLeft !== "Finished"
                ?
              <div>
                <div className="flex justify-around mt-8">
                  <div className="flex flex-col">
                    <div>
                      <div
                        onClick={this.buyBondingCurveItem}
                        className="hover:bg-zinc-800 dark:hover:bg-zinc-300 sm:ml-2 mx-auto bg-custom-black dark:bg-gray-200 h-12 w-32 sm:w-48 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer"
                      >
                        Buy
                      </div>
                      <div className="flex flex-col items-center justify-center">
                        <div className="flex items-center justify-center text-md dark:text-white font-bold">
                          {(this.props.item.baseBuyPrice / this.state.ethToWeiConversion).toFixed(3) + " ETH"}
                        </div>
                        <div className="text-sm text-gray-500">
                          {this.props.item.currentBuyFeePerThousand/10 + "% creator fee"}
                        </div>
                        <div className="flex text-sm text-gray-500">
                          {(this.props.item.mintPrice / this.state.ethToWeiConversion).toFixed(3) + " ETH"}
                          <div className="cursor-pointer">
                            <RiQuestionLine
                              onMouseEnter={() => this.setShouldShowBuyMessage(true)}
                              onMouseLeave={() => this.setShouldShowBuyMessage(false)}
                            />
                          </div>
                        </div>
                        {
                          this.state.shouldShowBuyMessage
                            ?
                          <div className="relative left-4 p-2 rounded-lg bg-custom-black dark:bg-gray-200 text-white dark:text-black">
                            {
                              "$ " + (((this.props.item.mintPrice / this.state.ethToWeiConversion)*this.state.USDPrice)).toFixed(2)
                            }
                          </div>
                            :
                          <div className="relative left-4 p-2 rounded-lg invisible">
                            {
                              "$ " + (((this.props.item.mintPrice / this.state.ethToWeiConversion)*this.state.USDPrice)).toFixed(2)
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  {
                    !this.props.item.isNonLiquid
                      ?
                    <div className="flex flex-col">
                      <div>
                        <div
                          onClick={this.sellBondingCurveItem}
                          className="hover:bg-gray-300 dark:hover:bg-zinc-700 mr-2 mx-auto bg-gray-400 dark:bg-zinc-800 dark:bg-zinc-800 h-12 w-32 sm:w-48 font-semibold justify-center items-center rounded-lg flex font-medium text-gray-200 dark:text-gray-300 cursor-pointer">
                          Sell
                        </div>
                        <div className="flex flex-col items-center justify-center">
                          <div className="text-md dark:text-white font-bold">
                            {(this.props.item.baseSellPrice / this.state.ethToWeiConversion).toFixed(3) + " ETH"}
                          </div>
                          <div className="text-sm text-gray-500">
                            {this.props.item.currentSellFeePerThousand/10 + "% creator fee"}
                          </div>
                          <div className="flex text-sm text-gray-500">
                            {(this.props.item.sellPrice / this.state.ethToWeiConversion).toFixed(3) + " ETH"}
                            <div className="cursor-pointer">
                              <RiQuestionLine
                                onMouseEnter={() => this.setShouldShowSellMessage(true)}
                                onMouseLeave={() => this.setShouldShowSellMessage(false)}
                              />
                            </div>
                          </div>
                          {
                            this.state.shouldShowSellMessage
                              ?
                            <div className="relative bottom-2 left-4 p-2 rounded-lg bg-custom-black dark:bg-gray-200 text-white dark:text-black">
                              {
                                "$ " + (((this.props.item.sellPrice / this.state.ethToWeiConversion)*this.state.USDPrice)).toFixed(2)
                              }
                            </div>
                              :
                            <div className="relative bottom-2 left-4 p-2 rounded-lg invisible">
                              {
                                "$ " + (((this.props.item.sellPrice / this.state.ethToWeiConversion)*this.state.USDPrice)).toFixed(2)
                              }
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                      :
                    null
                  }
                </div>
              </div>
                :
              <div className="h-28 bg-gray-100 dark:bg-custom-gray dark:border-t-1 dark:border-zinc-800 border-t-2 flex flex-col justify-center">
                <div className="flex justify-around">
                  <div onClick={async (e) => {
                    e.stopPropagation();
                    await this.handleClickMarketplace();
                  }}>
                    <div className="ml-2 mx-auto bg-custom-black dark:bg-gray-200 h-12 w-52 font-semibold justify-center items-center rounded-lg flex font-medium text-white dark:text-black cursor-pointer">
                      View on Marketplace
                    </div>
                  </div>
                </div>
              </div>
            }
            { crossmintPayButton }
            <div className="ml-4 sm:ml-2 flex w-full sm:w-3/4 justify-around mb-2">
              <div>
                <div className="text-gray-500 dark:text-gray-400 w-32 font-medium text-md">
                  {
                    !this.props.item.isNonLiquid
                      ?
                    "Liquidity Pool"
                      :
                    "Total Raised"
                  }
                </div>
                <div className="dark:text-white text-black font-bold text-2xl">
                  {(this.props.item.moneyInContract / this.state.ethToWeiConversion).toFixed(3) + " ETH"}
                </div>
              </div>
              <div>
                <div className="text-gray-500 dark:text-gray-400 w-32 font-medium text-md">
                  NFTs Held
                </div>
                <div className="dark:text-white text-black font-bold text-2xl">
                  {this.props.item.currentSupply}
                </div>
              </div>
            </div>
            {
              this.props.item.parameters.length > 1
                ?
              <ItemLiquidityGraph item={this.props.item} />
                :
              null
            }
          </div>
            :
          <div className = "videoMintDetails-OuterContainer">
            <div className = "videoMintDetails-contractDetailsContainer">
              <div className = "videoMintDetails-contractDetailsTopContainer">
                <div className = "videoMintDetails-contractDetailsContentsContainer">
                  <div className = "text-xs text-gray-500 dark:text-gray-300">
                    AVAILABLE NFTS
                  </div>
                  <div className = "videoMintDetails-contractInfo-Container">
                    {this.props.item.mintLimit - this.props.item.mintCount + "/" + this.props.item.mintLimit}
                  </div>
                </div>
                <div className = "videoMintDetails-contractDetailsContentsContainer">
                  <div className = "text-xs text-gray-500 dark:text-gray-300">
                    MINT PRICE
                  </div>
                  <div className = "videoMintDetails-contractInfo-Container">
                    {((this.props.item.mintPrice / this.state.ethToWeiConversion)).toFixed(3) + " ETH"}
                  </div>
                  <div className = "videoMintDetails-contractInfo-ContainerUSD">
                    {"$ " + (((this.props.item.mintPrice / this.state.ethToWeiConversion)*this.state.USDPrice)).toFixed(2)}
                  </div>
                </div>
              </div>
              <div className = "videoMintDetails-progressBarContainer">
                <div className = "videoMintDetails-progressBar">
                  <div style = {videoMintProgressBar}>
                  </div>
                </div>
              </div>
              <div className = "videoMintDetailsButtonContainer">
                {
                  this.props.account != null && this.props.item != null && this.props.item.isMintReady
                    ?
                  <div className = "videoMintDetails-mintButton" onClick={this.purchaseNFT}>
                    {
                      this.props.item["mintCount"] >= this.props.item["mintLimit"] || this.props.item["isMintComplete"]
                        ?
                      "Secondaries"
                        :
                      this.state.ethBalance >= this.props.item["mintPrice"]
                        ?
                      "Mint"
                        :
                      "Insufficient funds"
                    }
                  </div>
                    :
                  null
                }
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

export default ItemMintDetails;
